import styled from "styled-components";

export const StyledGroupDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 1rem;
`;
